import { graphql } from 'react-apollo';
import { USER_QUERY } from 'utils/graphql/userQueries';

export const getUserData = (operationOptions = {}) => {
  return graphql(USER_QUERY, operationOptions);
};
